import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import Request from "../based/Request";
import { Notify } from "../based/Notify";
import { NOTIFY, PLATFORM, PLATFORM_NAME } from "../based/Constants";
import TFUSelect from "../based/refactor/TFUSelect";
import PushingServices from "../based/services/PushingServices";
import Common from "../based/Common";
export const PushingPhotoshopProduct = {
    id: 0,
    photoshopFileId: 0,
    appProductId: 0,
    appProductName: "",
    appProductAvatar: "",
    pushingPhotoshopVariants: [],
};

const FileType = {
    Normal: 0,
    Case: 1,
};

export const PushingPhotoshopFile = {
    id: 0,
    name: "",
    fileUrl: "",
    thumbnail: "",
    fileProducts: [PushingPhotoshopProduct],
    appProductId: 0,
    appProductName: "",
    photoshopFileType: PLATFORM.Shopee,
    colorCode: "",
    photoshopFileTypeName: [],
    note: "",
    fileType: 0,
    artworkCount: 1,
    sex: 0,
};

const PhotoshopFileList = [
    {
        value: PLATFORM.Shopee,
        text: PLATFORM_NAME.Shopee,
    },
    {
        value: PLATFORM.Lazada,
        text: PLATFORM_NAME.Lazada,
    },
    {
        value: PLATFORM.Tiktok,
        text: PLATFORM_NAME.Tiktok,
    },
    {
        value: PLATFORM.Facebook,
        text: PLATFORM_NAME.Facebook,
    },
    {
        value: PLATFORM.Zalo,
        text: PLATFORM_NAME.Zalo,
    },
];

function PushingFileModal({ id, isShowModal, onClose, onSave }) {
    const [isBusy, setIsBusy] = useState(false);
    const [model, setModel] = useState(PushingPhotoshopFile);
    const [options, setOptions] = useState([]);
    const [productOptions, setProductOptions] = useState([]); // [ { value: 1, label: "Product 1" }
    const [productIds, setProductIds] = useState([]);
    const [colors, setColors] = useState([]);

    useEffect(() => {
        getOptions();
        getColor();
        getProductOptions().then(() => {
            if (id > 0) {
                getById(id);
            } else {
                setModel(PushingPhotoshopFile);
            }
        });
    }, [isShowModal]);

    const getById = async (id) => {
        setIsBusy(true);
        let [err, data] = await PushingServices.GetPhotoshopFileById(id);
        if (!err && data) {
            setModel(data);

            //config thông tin sản phẩm
            if (data.fileProducts) {
                let ids = data.fileProducts.reduce((prev, item, idx) => {
                    if (prev.includes(item.appProductId)) return prev;
                    return [...prev, item.appProductId];
                }, []);
                setProductIds(ids);
            }

            //config thông tin ignore product
            if (data.pushingPhotoshopFileIgnores && data.pushingPhotoshopFileIgnores.length > 0) {
                let ignorePool = data.pushingPhotoshopFileIgnores;

                let newProductOptions = productOptions.map((item) => {
                    let ignoreProductIds = ignorePool.filter((x) => x.templateAppProductId == item.value).map((x) => x.ignoreAppProductId);
                    return { ...item, ignoreProductIds };
                });
                setProductOptions(newProductOptions);
            }
        }
        setIsBusy(false);
    };

    const _handleSave = async () => {
        setIsBusy(true);

        //ignore product
        var ignoreProducts = productOptions.reduce((prev, item, idx) => {
            if (item.ignoreProductIds && item.ignoreProductIds.length > 0) {
                let listIgnore = item.ignoreProductIds.map((x) => ({
                    templateAppProductId: +item.value,
                    ignoreAppProductId: +x,
                }));
                prev = [...prev, ...listIgnore];
            }
            return prev;
        }, []);

        let md = { ...model, fileProducts: productIds.map((item) => ({ appProductId: item })), pushingPhotoshopFileIgnores: ignoreProducts };
        let [err, data] = await PushingServices.CreateOrUpdatePhotoshopFile(md);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
        }
        setIsBusy(false);
    };

    const handleUploadFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (!file) return;
        setIsBusy(true);

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            Request.UploadPhotoshop(file).then((res) => {
                if (res && res.data) {
                    const { fileUrl, fileName } = res.data;
                    setModel({ ...model, fileUrl, name: fileName });
                    Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Upload PSD thành công");
                } else {
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
                }
            });
        };

        setIsBusy(false);
    };

    const handleUploadThumbnail = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (!file) return;
        setIsBusy(true);
        Request.UploadImage(file).then((res) => {
            if (res && res.data) {
                const { imageUrl } = res.data;
                setModel({ ...model, thumbnail: imageUrl });
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Upload thumbnail thành công");
            } else {
                Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
            }
        });

        setIsBusy(false);
    };

    const getOptions = async () => {
        let [err, data] = await PushingServices.GetDropdownProduct();
        if (!err && data) {
            setOptions(data);
        } else {
            setOptions([]);
        }
    };

    const getProductOptions = async () => {
        let [err, data] = await PushingServices.GetDropdownProduct();
        if (!err && data) {
            setProductOptions(data);
        } else {
            setProductOptions([]);
        }
    };

    const getColor = async () => {
        let [err, data] = await PushingServices.GetColorValue();
        if (!err && data) {
            setColors(data);
        } else {
            setColors([]);
        }
    };

    return (
        <CommonModal show={isShowModal} size="lg" isBusy={isBusy} busyMsg={"Đang tải dữ liệu"} title={id > 0 ? "Cập nhật File PSD" : "Upload File PSD"} onSave={_handleSave} onClose={() => onClose()}>
            <Wrapper>
                <div className="row my-2">
                    <div className="col-md-12">
                        <div className="form-group form-row">
                            <label htmlFor="" className="required">
                                Loại sản phẩm
                            </label>
                            <div className="list-file-type ml-3">
                                <div
                                    className="file-type"
                                    onClick={(e) => {
                                        setModel({ ...model, fileType: FileType.Normal });
                                    }}
                                >
                                    <input type="checkbox" checked={model.fileType == FileType.Normal} onChange={(e) => {}} />
                                    <span>Áo thun/ Túi tote/ Bình nước/ Hộp bút</span>
                                </div>
                                <div
                                    className="file-type my-3"
                                    onClick={(e) => {
                                        setModel({ ...model, fileType: FileType.Case });
                                    }}
                                >
                                    <input type="checkbox" checked={model.fileType == FileType.Case} onChange={(e) => {}} />
                                    <span>Ốp lưng</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group form-row">
                            <label htmlFor="fileUrl" className="required mb-1">
                                File render hình
                            </label>
                            <div className="sub-instruction col-md-12 mb-2 pl-0">Định dạng PSD</div>
                            <input
                                type="file"
                                className="col-md-12 pl-0"
                                name="fileUrl"
                                id="fileUrl"
                                placeholder="Chọn file"
                                onChange={(e) => {
                                    handleUploadFile(e);
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group form-row">
                            <label htmlFor="thumbnail" className="required mb-1">
                                Hình mô tả
                            </label>
                            <div className="sub-instruction col-md-12 mb-2 pl-0">Định dạng JPG hoặc PNG</div>
                            <input
                                type="file"
                                className="col-md-12 pl-0"
                                name="thumbnail"
                                id="thumbnail"
                                placeholder="Hình mô tả"
                                onChange={(e) => {
                                    handleUploadThumbnail(e);
                                }}
                            />
                        </div>
                        <div className="thumbnail-avatar">{model.thumbnail && <img src={model.thumbnail} />}</div>
                    </div>
                </div>
                <div className="row my-2">
                    <div className="form-group form-row col-md-12">
                        <label htmlFor="name" className="required">
                            Tên file
                        </label>
                        <input type="text" className="form-control" name="name" id="name" placeholder="Tên file" value={model.name} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                    </div>
                </div>
                <div className="row my-2">
                    <div className="form-group form-row col-md-6">
                        <label htmlFor="sex" className="required col-md-12">
                            Giới tính
                        </label>
                        {/* Tạo 2 radio box cho 1 mặt và 2 mặt */}
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="sex1" id="sex1" value="0" checked={model.sex == 0} onChange={(e) => setModel({ ...model, sex: 0 })} />
                            <label className="form-check-label" htmlFor="sex1">
                                Nam
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="sex2" id="sex2" value="1" checked={model.sex == 1} onChange={(e) => setModel({ ...model, sex: 1 })} />
                            <label className="form-check-label" htmlFor="sex2">
                                Nữ
                            </label>
                        </div>
                    </div>
                    <div className="form-group form-row col-md-6">
                        <label htmlFor="artworkCount" className="required col-md-12">
                            Số mặt
                        </label>
                        {/* Tạo 2 radio box cho 1 mặt và 2 mặt */}
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="artworkCount" id="artworkCount1" value="1" checked={model.artworkCount == 1} onChange={(e) => setModel({ ...model, artworkCount: 1 })} />
                            <label className="form-check-label" htmlFor="artworkCount1">
                                1 mặt
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="artworkCount" id="artworkCount2" value="2" checked={model.artworkCount == 2} onChange={(e) => setModel({ ...model, artworkCount: 2 })} />
                            <label className="form-check-label" htmlFor="artworkCount2">
                                2 mặt
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row my-2">
                    <div className="form-group form-row col-md-12">
                        <label htmlFor="" className="required col-md-12">
                            Sàn áp dụng
                        </label>
                        {PhotoshopFileList.map((item, index) => {
                            return (
                                <div key={index} className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="photoshopFileType"
                                        id={item.value}
                                        value={item.value}
                                        checked={Common.hasFlag(model.photoshopFileType, +item.value)}
                                        onChange={(e) => {
                                            //bitwise operator check
                                            let md = { ...model };
                                            let ptsFile = md.photoshopFileType;
                                            if (Common.hasFlag(ptsFile, +e.target.value)) {
                                                //remove flag
                                                ptsFile = ptsFile ^ +e.target.value;
                                            } else {
                                                //add flag
                                                ptsFile = ptsFile | +e.target.value;
                                            }
                                            setModel({ ...model, photoshopFileType: ptsFile });
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor={item.value}>
                                        {item.text}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {model.fileType == FileType.Normal && (
                    <React.Fragment>
                        <div className="row my-2">
                            <div className="form-group form-row col-md-6">
                                <label className="col-md-12" htmlFor="colorCode">
                                    Màu sản phẩm
                                </label>
                                <TFUSelect name="colorCode" className="col-md-12" id="colorCode" value={model.colorCode} options={colors} onChanged={(value) => setModel({ ...model, colorCode: value })} />
                            </div>
                        </div>
                        <div className="row my-2">
                            <div className="form-group form-row col-md-12">
                                <label htmlFor="fileProducts" className="required">
                                    Dòng sản phẩm có trong file
                                </label>
                                <div className="card-box">
                                    {productOptions &&
                                        productOptions.length &&
                                        productOptions.map((item, index) => {
                                            return (
                                                <div
                                                    className="card-item cursor-pointer"
                                                    key={index}
                                                    onClick={() => {
                                                        let index = productIds.indexOf(+item.value);
                                                        if (index >= 0) {
                                                            productIds.splice(index, 1);
                                                        } else {
                                                            productIds.push(+item.value);
                                                        }
                                                        setProductIds([...productIds]);
                                                    }}
                                                >
                                                    <div className="check-item">
                                                        <input type="checkbox" value={productIds.includes(+item.value)} checked={productIds.includes(+item.value)} />
                                                    </div>
                                                    <div className="check-content">
                                                        <label>{item.label}</label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>

                        <div className="row my-2">
                            <div className="form-group form-row col-md-12">
                                <label className="required">Loại trừ biến thể khi đẩy lên sàn Ecom</label>
                                <div className="col-md-12">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="center">Dòng sản phẩm mẫu</th>
                                                <th className="center">Dòng sản phẩm không đưa vào biến thể</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productOptions &&
                                                productOptions.length &&
                                                productOptions.map((item, index) => {
                                                    let anyItem = productIds.includes(+item.value);
                                                    if (!anyItem) return null;
                                                    return (
                                                        <tr key={index}>
                                                            <td className="center">{item.label}</td>
                                                            <td className="center">
                                                                <div className="select-item">
                                                                    <TFUSelect
                                                                        options={productOptions}
                                                                        onChanged={(value) => {
                                                                            let pos = [...productOptions];
                                                                            let posItem = pos[index];
                                                                            let lstIgnore = posItem.ignoreProductIds || [];
                                                                            if (!lstIgnore.includes(+value)) {
                                                                                lstIgnore.push(+value);
                                                                            }
                                                                            posItem.ignoreProductIds = lstIgnore;
                                                                            pos[index] = posItem;
                                                                            setProductOptions([...pos]);
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="list-product-tab-item">
                                                                    {item.ignoreProductIds &&
                                                                        item.ignoreProductIds.map((ele, i) => {
                                                                            let name = productOptions.find((x) => x.value == ele)?.label;
                                                                            return (
                                                                                <span className="badge m-1" key={i}>
                                                                                    {name}
                                                                                    <div
                                                                                        className="icon cursor-pointer"
                                                                                        onClick={(e) => {
                                                                                            let pos = [...productOptions];
                                                                                            let posItem = pos[index];
                                                                                            let lstIgnore = posItem.ignoreProductIds || [];
                                                                                            lstIgnore = lstIgnore.filter((x) => x != ele);
                                                                                            posItem.ignoreProductIds = lstIgnore;
                                                                                            pos[index] = posItem;
                                                                                            setProductOptions([...pos]);
                                                                                        }}
                                                                                    >
                                                                                        <RemoveIcon />
                                                                                    </div>
                                                                                </span>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </Wrapper>
        </CommonModal>
    );
}

export default PushingFileModal;

const Wrapper = styled.div`
    .list-product-tab-item {
        display: flex;
        margin: 10px 0;
    }

    .list-product-tab-item span {
        display: flex;
        align-items: center;
    }

    .list-product-tab-item span .icon {
        margin-left: 6px;
    }

    .file-type {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .file-type span {
        color: #676767;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    .thumbnail-avatar {
        width: 200px;
        height: 200px;
    }

    .thumbnail-avatar img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .card-box {
        border: 1px solid;
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
    }

    .card-item {
        width: calc(33.33% - 20px);
        margin: 10px;
        display: flex;
        align-items: center;
    }

    .check-content label {
        margin: 0 0 0 10px !important;
    }
`;

const RemoveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <path d="M7 1L1 7" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 7L1 1" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};
